import React, { useState } from "react";
import { useTheme } from "styled-components";
import { isEqual } from "lodash";

import SidebarTransition from "@Shared/Components/MacroSidebar/SidebarTransition";
import DualColorPicker from "@Shared/Components/ColorPicker/DualColorPicker";
import EyeDropperIcon from "@Shared/Components/ColorPicker/icons/EyeDropperIcon";
import getReadableColor from "@Shared/Components/ColorPicker/getReadableColor";

import {
  ColorPickerContainer,
  ColorPickerTile,
  ComponentWrapper,
} from "./styles/colorpicker";

import { useOpticsStore } from "../../../stores/use-optics-store";
import { DEFAULT_COLORS } from "../../../styleguide/onboarding/components/ui/color-pair/templates/colors";

const getColors = (selectedColors) => {
  let colors = selectedColors?.dark?.length ? selectedColors : DEFAULT_COLORS;

  colors = colors.dark.map((dark) => {
    const light = colors.light.find(({ id }) => dark.id === id);

    return {
      accent: { light: light.accent, dark: dark.accent },
      text: { light: light.text, dark: dark.text },
    };
  });

  return colors;
};

const ColorPicker = ({ value, hideColorTiles, onChange = () => {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { selectedColors } = useOpticsStore((state) => state.styleguideSetup);

  const theme = useTheme();
  const styleguideColors = getColors(selectedColors);

  const checkIsSelected = (colors) => {
    if (hideColorTiles) {
      return isEqual(value.accent, colors.accent);
    }

    return isEqual(value, colors);
  };

  const getEyeDropperColor = () => {
    if (hideColorTiles) {
      return getReadableColor(value.accent[theme.name]);
    }

    return value.text[theme.name];
  };

  const getPickerColors = () => {
    const isCustomColor = styleguideColors.every(
      (colors) => !checkIsSelected(colors)
    );

    return {
      text: isCustomColor ? getEyeDropperColor() : "#000",
      accent: isCustomColor ? value.accent[theme.name] : "#ddd",
    };
  };

  return (
    <>
      <ComponentWrapper>
        <ColorPickerContainer>
          {styleguideColors.map((colors) => (
            <ColorPickerTile
              isSelected={checkIsSelected(colors)}
              accent={colors.accent[theme.name]}
              text={colors.text[theme.name]}
              onClick={() => onChange(colors)}
            >
              {!hideColorTiles && "Aa"}
            </ColorPickerTile>
          ))}

          <ColorPickerTile
            {...getPickerColors()}
            style={{ borderRadius: "4px" }}
            onClick={() => setIsOpen(true)}
          >
            <EyeDropperIcon />
          </ColorPickerTile>
        </ColorPickerContainer>
      </ComponentWrapper>

      <SidebarTransition
        isOpen={isOpen}
        position="right"
        width={280}
        shouldHideScrollbar
        containerStyles={{ top: "75px" }}
        additionalStyle={{ padding: "0 13px 0 0" }}
        close={() => {
          setIsOpen(false);
          window.AP.events.emit("theme-changed", null);
        }}
      >
        {isOpen && (
          <DualColorPicker
            value={value}
            hideColorTiles={hideColorTiles}
            defaultTheme={theme.name}
            setValue={onChange}
            width={240}
            height={200}
          />
        )}
      </SidebarTransition>
    </>
  );
};

export default ColorPicker;
